'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChash160 = getChash160;
exports.toWif = toWif;
exports.fromWif = fromWif;

var _wif = require('wif');

var _wif2 = _interopRequireDefault(_wif);

var _internal = require('./internal');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getChash160(obj) {
  return (0, _internal.chashGetChash160)((0, _internal.getSourceString)(obj));
}

function toWif(privateKey, testnet) {
  var version = testnet ? 239 : 128;
  return _wif2.default.encode(version, privateKey, false);
}

function fromWif(string, testnet) {
  var version = testnet ? 239 : 128;
  return _wif2.default.decode(string, version);
}